import { createSelector } from '@reduxjs/toolkit';

import { GalleryImage } from 'editor/src/store/gallery/types';
import { RootState } from 'editor/src/store/index';

import { LibraryRequest } from '../types';

export const isLibraryEnabled = (state: RootState) => state.editorModules.customerLibrary.enabled;

export const getLibraryImages = (state: RootState) => state.editorModules.customerLibrary.images;

export const getLibraryImageById = (state: RootState, imageId: string): GalleryImage | undefined =>
  getLibraryImages(state).find((image) => image.id === imageId);

// every gallery tile asks, so the lookup must not scan the library per tile
export const getLibraryImageIds = createSelector(
  getLibraryImages,
  (images) => new Set(images.map((image) => image.id)),
);

export const isImageSaved = (state: RootState, imageId: string) => getLibraryImageIds(state).has(imageId);

export const getLibraryRequest = (state: RootState, imageId: string): LibraryRequest | undefined =>
  state.editorModules.customerLibrary.requests[imageId];
